import React from 'react';
import { motion } from 'framer-motion';

const Navbar = ({ user, collapsed }) => {

  const styles = `
    .navbar {
      position: fixed;
      top: 0;
      right: 0;
      left: ${collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)'};
      height: var(--header-height);
      background: #ffffff;
      border-bottom: 1px solid #e2e8f0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 var(--page-padding);
      z-index: 50;
      transition: left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .navbar-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .icon-button {
      position: relative;
      width: 40px;
      height: 40px;
      border-radius: var(--radius-md);
      background: #f1f5f9;
      border: 1px solid #e2e8f0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
    }

    .icon-button:hover {
      background: #e2e8f0;
      transform: scale(1.05);
    }

    .icon-button svg {
      width: 20px;
      height: 20px;
      color: #1e293b;
    }

    .notification-dot {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 8px;
      height: 8px;
      background: hsl(var(--destructive));
      border-radius: 50%;
      border: 2px solid hsl(var(--card));
      animation: pulse-glow 2s ease-in-out infinite;
    }

    .user-button {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 12px;
      border-radius: var(--radius-md);
      background: #f1f5f9;
      border: 1px solid #e2e8f0;
      cursor: pointer;
      transition: all 0.2s;
    }

    .user-button:hover {
      background: #e2e8f0;
    }

    .user-avatar {
      width: 32px;
      height: 32px;
      border-radius: var(--radius-md);
      background: var(--gradient-primary);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: 700;
      color: white;
    }

    .user-details {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .user-name {
      font-size: 13px;
      font-weight: 600;
      color: #1e293b !important;
      line-height: 1.2;
    }

    .user-email {
      font-size: 11px;
      color: #475569 !important;
      line-height: 1.2;
    }

    @media (max-width: 768px) {
      .navbar {
        left: 0;
      }

      .user-details {
        display: none;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <motion.div
        className="navbar"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {/* Right Section - Icons & User */}
        <div className="navbar-right">
          {/* User Profile */}
          <button className="user-button" title="Profile">
            <div className="user-avatar">
              {user?.full_name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.full_name || 'User'}</div>
              <div className="user-email">{user?.role === 'admin' && !user?.tenant_id ? 'Super Admin' : user?.role ? user.role.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'User'}</div>
            </div>
          </button>
        </div>
      </motion.div>
    </>
  );
};

export default Navbar;
